import {Component, forwardRef, Input, OnDestroy, OnInit, SimpleChanges} from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from "@angular/forms";
import {Subject} from "rxjs";
import {KeyCode} from "../../../utils/key-code";
import {debounceTime, map} from "rxjs/operators";

@Component({
    selector: 'db-fc-search-input',
    templateUrl: './fc-search-input.component.html',
    styleUrls: ['./fc-search-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FcSearchInputComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FcSearchInputComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class FcSearchInputComponent implements OnInit, OnDestroy, ControlValueAccessor, Validator {

  @Input() value: string;
  @Input() placeholder: string;
  @Input() placeholderTitle: string;
  @Input() bigSize: boolean;
  @Input() grayStyle: boolean;

  public onChange: Subject<Event>;
  private _propagateChange: Function = (_: any) => {};


  constructor() {
    this.onChange = new Subject<Event>();
  }

  ngOnInit() {
    this.onChange
      .pipe(map((event: Event) => event.target['value']),
      debounceTime(200))
      .subscribe((value) => {
        this.value = value;
        this._propagateChange(value);
      });
  }

  ngOnDestroy() {
    this.onChange.unsubscribe();
    this.onChange = null;
  }

  ngOnChagnes(changes: SimpleChanges) {
    if (changes['value']) {
      this.value = changes['value'].currentValue || '';
    }

    if (changes['placeholder']) {
      this.placeholder = changes['placeholder'].currentValue || '';
    }
    if (changes['placeholderTitle']) {
      this.placeholderTitle = changes['placeholderTitle'].currentValue || '';
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this._propagateChange = fn;
  }

  registerOnTouched(fn: any): void {}

  validate(c: AbstractControl): ValidationErrors {
    return null;
  }

  registerOnValidatorChange(fn: () => void): void {}

  setDisabledState(isDisabled: boolean): void {}

  public onKeydown($event: any): void {
    if ($event.keyCode === KeyCode.ESCAPE && this.value !== '') {
      this.value = '';
      this._propagateChange('');
    }
  }

  public clearValue(): void {
    this.value = '';
    this._propagateChange('');
  }

}
